import * as React from 'react'
import ReactSelect, { Props as ReactSelectProps } from 'react-select'
import { Input } from '../input/input'
import { useSelectStyles } from './useSelectStyles'
import { OptionTypeBase } from '../../interface/optionTypeBase'

export interface SelectProps<OptionType extends OptionTypeBase>
  extends ReactSelectProps<OptionType> {
  invalid?: boolean
  readOnly?: boolean
}

function SelectWithRef<
  OptionType extends OptionTypeBase = { label: string; value: string }
>(
  {
    invalid,
    readOnly,
    styles,
    getOptionLabel = (option: OptionType): string => option.label,
    ...props
  }: SelectProps<OptionType>,
  ref: React.RefObject<any>
) {
  if (readOnly) {
    const displayValue = props.value
      ? getOptionLabel(props.value as OptionType)
      : ''

    return (
      <Input id={props.inputId} type="text" readOnly value={displayValue} />
    )
  } else {
    const selectStyles = useSelectStyles(invalid, styles)

    return (
      <ReactSelect<OptionType, boolean>
        {...props}
        getOptionLabel={getOptionLabel}
        styles={selectStyles}
        ref={ref}
      />
    )
  }
}

export const Select = React.forwardRef(SelectWithRef) as <
  OptionType extends OptionTypeBase = { label: string; value: string }
>(
  props: SelectProps<OptionType> & { ref?: React.RefObject<any> }
) => ReturnType<typeof SelectWithRef>
